import { DataProvider } from 'react-admin'
import { AccessDto } from '../../dto/access.dto'
import { AccessActivePeriodStartingOptions } from '../../enum/AccessActivePeriodStartingOptions'
import { DayOfWeek } from '../../enum/DayOfWeek'
import { AccessTicketPeriodOptions } from '../../enum/AccessTicketPeriodOptions'
import { DeferLogicOptions } from '../../enum/DeferLogicOptions'

const fakeAccesses: AccessDto[] = [
  {
    id: 1,
    name: 'access1',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 2,
    name: 'access2',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 3,
    name: 'access3',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 4,
    name: 'access4',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 5,
    name: 'access5',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 6,
    name: 'access6',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 7,
    name: 'access7',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 8,
    name: 'access8',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 9,
    name: 'access9',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
  {
    id: 10,
    name: 'access10',
    bonusId: 1,
    entranceId: 0,
    allowReenter: false,
    multipleExit: false,
    multiplicity: 0,
    usePriority: 0,
    ticketUnlockOption: AccessTicketPeriodOptions.IMMEDIATELY,
    unlockTime: '2021-07-15T08:50:27.2054',
    unlockDayOfWeek: DayOfWeek.Monday,
    unlockDayOfMonth: 1,
    unlockDelay: '',
    ticketDeferOption: AccessTicketPeriodOptions.IMMEDIATELY,
    deferTime: '2021-07-15T08:50:27.2054',
    deferDayOfWeek: DayOfWeek.Monday,
    deferDayOfMonth: 1,
    deferDelay: '',
    deferLogic: DeferLogicOptions.FROM_ENTRANCE,
    markNewBookingAsUsed: false,
    activePeriod: '',
    activePeriodStartingFrom: AccessActivePeriodStartingOptions.FIRST_USE,
    variantsIds: [],
    accessDatesIds: [],
    createdById: 0,
    modifiedById: 0,
    createdAt: '2021-07-15T08:50:27.2054',
    modifiedAt: '2021-07-15T08:50:27.2054',
    restrictLicencePlate: false,
    allowAddLicencePlate: false,
  },
]

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeAccesses, total: fakeAccesses.length }),
} as DataProvider

export default provider
